import { render, staticRenderFns } from "./NavbarInstall.vue?vue&type=template&id=f949c990&scoped=true"
import script from "./NavbarInstall.vue?vue&type=script&lang=js"
export * from "./NavbarInstall.vue?vue&type=script&lang=js"
import style0 from "./NavbarInstall.vue?vue&type=style&index=0&id=f949c990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f949c990",
  null
  
)

export default component.exports